export const mapStepProps = {
  // these are the parameters for the map, they're picked out by index in computed property. some are vestigial for this usage.
  "FOSSIL":
  {
    isElectric: false,
    selectedScenario: 'BAU',
    selectedMetric: 'ALL_ENERGY',
    selectedFutureMetric: 'ALL_ENERGY',
    selectedUSState: 'The United States',
    stashedUSState: 'The United States',
    selectedExploreView: 'SCENARIOS',
    selectedFuelType: 'GAS'
  },
  "BAU":
  {
    isElectric: true,
    selectedScenario: 'BAU',
    selectedMetric: 'ALL_ENERGY',
    selectedFutureMetric: 'ALL_ENERGY',
    selectedUSState: 'The United States',
    stashedUSState: 'The United States',
    selectedExploreView: 'SCENARIOS',
    selectedFuelType: 'GAS'
  },
  /*"GOOD":
  {
    isElectric: true,
    selectedScenario: 'GOOD',
    selectedMetric: 'ALL_ENERGY',
    selectedFutureMetric: 'ALL_ENERGY',
    selectedUSState: 'The United States',
          stashedUSState: 'The United States',
    selectedExploreView: 'SCENARIOS',
    selectedFuelType: 'GAS'
  },*/
  "BETTER":
  {
    isElectric: true,
    selectedScenario: 'BETTER',
    selectedMetric: 'ALL_ENERGY',
    selectedFutureMetric: 'ALL_ENERGY',
    selectedUSState: 'The United States',
    stashedUSState: 'The United States',
    selectedExploreView: 'SCENARIOS',
    selectedFuelType: 'GAS'
  },
  "BEST":
  {
    isElectric: true,
    selectedScenario: 'BEST',
    selectedMetric: 'ALL_ENERGY',
    selectedFutureMetric: 'ALL_ENERGY',
    selectedUSState: 'The United States',
    stashedUSState: 'The United States',
    selectedExploreView: 'SCENARIOS',
    selectedFuelType: 'GAS'
  }
}
